import React from "react";
import { ExternalLink, ClipboardCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { log } from "@/lib/log";
import { OFFICIAL_CALCULATORS } from "@/lib/lenses";

function eyeLine(label, e) {
  if (!e) return `${label}: —`;
  return `${label}: AL ${e.al} | ACD ${e.acd} | LT ${e.lt} | WTW ${e.wtw} | K1 ${e.k1} @ ${e.k1_axis} | K2 ${e.k2} @ ${e.k2_axis}`;
}

export function biometryClipboardText(req) {
  return [
    `Patient ${req.patient_name || "—"}${req.patient_id ? ` (${req.patient_id})` : ""}${req.age ? ` · ${req.age} y` : ""}`,
    eyeLine("OD", req.od),
    eyeLine("OS", req.os),
    `Barrett A-const ${req.a_constant} · Other formulas A-const ${req.a_constant_other ?? req.a_constant} · Target ${req.target_refraction} D · Prior surgery ${req.prior_surgery}`,
  ].join("\n");
}

export default function CrossCheckBar({ request }) {
  const open = async (key) => {
    const c = OFFICIAL_CALCULATORS[key];
    try {
      await navigator.clipboard.writeText(biometryClipboardText(request));
      toast.success("Biometry copied — paste into the official calculator", { icon: <ClipboardCheck className="w-4 h-4" /> });
    } catch (err) {
      log.warn("Clipboard unavailable", err);
      toast.message("Opening official calculator (clipboard unavailable)");
    }
    window.open(c.url, "_blank", "noopener,noreferrer");
  };

  const showTrueK = request.prior_surgery && request.prior_surgery !== "none";

  return (
    <div
      className="rounded-xl border border-slate-200 bg-slate-50 px-4 py-3 flex flex-wrap items-center gap-2"
      data-testid="cross-check-bar"
    >
      <div className="text-xs text-slate-600 mr-auto">
        <span className="font-semibold text-slate-800">Cross-check with the official calculators.</span>{" "}
        Each button copies this patient's biometry to your clipboard and opens the site in a new tab.
      </div>
      <Button size="sm" variant="outline" onClick={() => open("escrs")} data-testid="open-escrs-btn">
        <ExternalLink className="w-3.5 h-3.5 mr-1.5" /> {OFFICIAL_CALCULATORS.escrs.label}
      </Button>
      <Button size="sm" variant="outline" onClick={() => open("barrett")} data-testid="open-barrett-btn">
        <ExternalLink className="w-3.5 h-3.5 mr-1.5" /> {OFFICIAL_CALCULATORS.barrett.label}
      </Button>
      {showTrueK && (
        <Button size="sm" variant="outline" onClick={() => open("truek")} data-testid="open-truek-btn">
          <ExternalLink className="w-3.5 h-3.5 mr-1.5" /> {OFFICIAL_CALCULATORS.truek.label}
        </Button>
      )}
    </div>
  );
}
